module.exports = __webpack_public_path__ + "img/pantalla-2-11.bd02449a.png";